import { createFileRoute } from '@tanstack/react-router';

import { CatalogOperationsPage } from '~/features/catalog-operations/pages/catalog-operations-page';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';

/** Deep link into the Schedules section (e.g. "Open" on Platform ▸ Schedules):
 *  `?tab=schedules` expands it, `&scheduleId=` narrows and highlights that schedule. */
interface CatalogOperationsSearch {
  tab?: 'schedules';
  scheduleId?: string;
}

export const Route = createFileRoute('/_authenticated/_tenant/catalog-operations/')({
  validateSearch: (search: Record<string, unknown>): CatalogOperationsSearch => ({
    ...(search.tab === 'schedules' ? { tab: 'schedules' as const } : {}),
    ...(typeof search.scheduleId === 'string' && search.scheduleId
      ? { scheduleId: search.scheduleId }
      : {}),
  }),
  component: RouteComponent,
});

/** Passes the schedules deep link down; everything else on the page is URL-independent. */
function RouteComponent() {
  const { tab, scheduleId } = Route.useSearch();
  return (
    <RequireChannelConnection>
      <CatalogOperationsPage
        schedulesFocus={tab === 'schedules' || scheduleId ? { scheduleId } : undefined}
      />
    </RequireChannelConnection>
  );
}
